"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var aggregationsMenuHelper_1 = tslib_1.__importDefault(require("./aggregationsMenuHelper"));
var AggregationsSubMenu_1 = tslib_1.__importDefault(require("./AggregationsSubMenu"));
var tableDescriptorTypes_1 = require("../tableDescriptorTypes");
var locales_1 = require("../../../locales");
/*
 * TODO: same thing is in sdk-ui-ext .. but pivot must not depend on it. we may be in need of some lower-level
 *  project on which both of filters and ext can depend. perhaps the purpose of the new project would be to provide
 *  thin layer on top of goodstrap (?)
 */
var SHOW_DELAY_DEFAULT = 200;
var HIDE_DELAY_DEFAULT = 0;
var MenuToggler = function () {
    var _a, _b;
    var theme = sdk_ui_theme_provider_1.useTheme();
    return (react_1.default.createElement("div", { className: "menu-icon" },
        react_1.default.createElement(sdk_ui_kit_1.Icon.BurgerMenu, { color: (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.complementary) === null || _b === void 0 ? void 0 : _b.c8 })));
};
var AggregationsMenu = /** @class */ (function (_super) {
    tslib_1.__extends(AggregationsMenu, _super);
    function AggregationsMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AggregationsMenu.prototype.render = function () {
        var _a = this.props, intl = _a.intl, colId = _a.colId, getTableDescriptor = _a.getTableDescriptor, isMenuOpened = _a.isMenuOpened, onMenuOpenedChange = _a.onMenuOpenedChange;
        if (!colId) {
            return null;
        }
        // Because of Ag-grid react wrapper does not rerender the component when we pass
        // new gridOptions we need to pull the data manually on each render
        var tableDescriptor = getTableDescriptor();
        if (!tableDescriptor.canTableHaveTotals()) {
            return null;
        }
        var col = tableDescriptor.getCol(colId);
        if (tableDescriptorTypes_1.isSliceCol(col) || tableDescriptorTypes_1.isRootCol(col)) {
            // aggregation menu should not appear on headers of the slicing columns or on the
            // very to header which describes table grouping
            return null;
        }
        var measures = tableDescriptorTypes_1.isSeriesCol(col)
            ? [col.seriesDescriptor.measureDescriptor]
            : tableDescriptor.getMeasures();
        var measureLocalIdentifiers = measures.map(function (m) { return m.measureHeaderItem.localIdentifier; });
        var totalsForHeader = this.getColumnTotals(measureLocalIdentifiers, tableDescriptorTypes_1.isScopeCol(col));
        return (react_1.default.createElement(sdk_ui_kit_1.Menu, { toggler: react_1.default.createElement(MenuToggler, null), togglerWrapperClassName: this.getTogglerClassNames(), opened: isMenuOpened, onOpenedChange: onMenuOpenedChange, openAction: "click", closeOnScroll: true },
            react_1.default.createElement(sdk_ui_kit_1.ItemsWrapper, null,
                react_1.default.createElement("div", { className: "s-table-header-menu-content" },
                    react_1.default.createElement(sdk_ui_kit_1.Header, null, intl.formatMessage({ id: "visualizations.menu.aggregations" })),
                    this.renderMainMenuItems(totalsForHeader, measureLocalIdentifiers, tableDescriptor.getSlicingAttributes())))));
    };
    AggregationsMenu.prototype.getColumnTotals = function (measureLocalIdentifiers, isGroupedHeader) {
        var _a, _b, _c;
        var columnTotals = (_c = (_b = (_a = this.props).getTotals) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : [];
        if (isGroupedHeader) {
            return aggregationsMenuHelper_1.default.getTotalsForAttributeHeader(columnTotals, measureLocalIdentifiers);
        }
        return aggregationsMenuHelper_1.default.getTotalsForMeasureHeader(columnTotals, measureLocalIdentifiers[0]);
    };
    AggregationsMenu.prototype.getTogglerClassNames = function () {
        var _a = this.props, isMenuButtonVisible = _a.isMenuButtonVisible, isMenuOpened = _a.isMenuOpened;
        return classnames_1.default("s-table-header-menu", "gd-pivot-table-header-menu", {
            "gd-pivot-table-header-menu--show": isMenuButtonVisible,
            "gd-pivot-table-header-menu--hide": !isMenuButtonVisible,
            "gd-pivot-table-header-menu--open": isMenuOpened,
        });
    };
    AggregationsMenu.prototype.renderMenuItemContent = function (totalType, onClick, isSelected, hasSubMenu, disabled, tooltipMessage) {
        if (hasSubMenu === void 0) { hasSubMenu = false; }
        var intl = this.props.intl;
        var onClickHandler = disabled ? noop_1.default : onClick;
        var itemElement = (react_1.default.createElement(sdk_ui_kit_1.Item, { checked: isSelected, subMenu: hasSubMenu, disabled: disabled },
            react_1.default.createElement("div", { onClick: onClickHandler, className: "gd-aggregation-menu-item-inner s-menu-aggregation-inner" }, intl.formatMessage(locales_1.messages[totalType]))));
        return disabled ? (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { showDelay: SHOW_DELAY_DEFAULT, hideDelay: HIDE_DELAY_DEFAULT },
            itemElement,
            react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary", alignPoints: [{ align: "bc tc" }] }, tooltipMessage))) : (itemElement);
    };
    AggregationsMenu.prototype.getItemClassNames = function (totalType) {
        return classnames_1.default("gd-aggregation-menu-item", "s-menu-aggregation", "s-menu-aggregation-" + totalType);
    };
    AggregationsMenu.prototype.isTableFilteredByMeasureValue = function () {
        var definition = this.props.getExecutionDefinition();
        // ignore measure value filters without condition, these are not yet specified by the user and are not sent as part of the execution
        return definition.filters.some(function (filter) { return sdk_model_1.isMeasureValueFilter(filter) && !!sdk_model_1.measureValueFilterCondition(filter); });
    };
    AggregationsMenu.prototype.isTableFilteredByRankingFilter = function () {
        var definition = this.props.getExecutionDefinition();
        return definition.filters.some(sdk_model_1.isRankingFilter);
    };
    AggregationsMenu.prototype.renderMainMenuItems = function (columnTotals, measureLocalIdentifiers, rowAttributeDescriptors) {
        var _this = this;
        var _a = this.props, intl = _a.intl, onAggregationSelect = _a.onAggregationSelect, showSubmenu = _a.showSubmenu, availableTotalTypes = _a.availableTotalTypes;
        var firstAttributeIdentifier = sdk_model_1.attributeDescriptorLocalId(rowAttributeDescriptors[0]);
        var isFilteredByMeasureValue = this.isTableFilteredByMeasureValue();
        var isFilteredByRankingFilter = this.isTableFilteredByRankingFilter();
        return availableTotalTypes.map(function (totalType) {
            var isSelected = aggregationsMenuHelper_1.default.isTotalEnabledForAttribute(firstAttributeIdentifier, totalType, columnTotals);
            var attributeDescriptor = rowAttributeDescriptors[0];
            var onClick = function () {
                return _this.props.onAggregationSelect({
                    type: totalType,
                    measureIdentifiers: measureLocalIdentifiers,
                    include: !isSelected,
                    attributeIdentifier: attributeDescriptor.attributeHeader.localIdentifier,
                });
            };
            var itemClassNames = _this.getItemClassNames(totalType);
            var disabled = totalType === "nat" && (isFilteredByMeasureValue || isFilteredByRankingFilter);
            var cause = isFilteredByMeasureValue ? locales_1.messages["disabled.mvf"] : locales_1.messages["disabled.ranking"];
            var tooltipMessage = disabled ? intl.formatMessage(cause) : undefined;
            var renderSubmenu = !disabled && showSubmenu && rowAttributeDescriptors.length > 0;
            var toggler = _this.renderMenuItemContent(totalType, onClick, isSelected, renderSubmenu, disabled, tooltipMessage);
            return (react_1.default.createElement("div", { className: itemClassNames, key: totalType }, renderSubmenu ? (react_1.default.createElement(AggregationsSubMenu_1.default, { intl: intl, totalType: totalType, rowAttributeDescriptors: rowAttributeDescriptors, columnTotals: columnTotals, measureLocalIdentifiers: measureLocalIdentifiers, onAggregationSelect: onAggregationSelect, toggler: toggler })) : (toggler)));
        });
    };
    return AggregationsMenu;
}(react_1.default.Component));
exports.default = AggregationsMenu;
//# sourceMappingURL=AggregationsMenu.js.map